import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Alert from "../common/Alert";

import { sendPasswordResetLink } from "../../store/auth-slice";
import { uiActions } from "../../store/ui-slice";
import { validateEmail } from "../../helpers/validations";

const SendResetLinkForm = (props) => {
  const notification = useSelector((state) => state.ui.notification);
  const dispatch = useDispatch();
  const emailInputRef = useRef();

  const sendResetLinkButtonHandler = async (event) => {
    event.preventDefault();

    if (!validateEmail(emailInputRef.current.value)) {
      dispatch(
        uiActions.enqueNotification({
          message: "Invalid email address",
          variant: "error",
        })
      );
      return;
    }
    dispatch(sendPasswordResetLink(emailInputRef.current.value));
  };

  return (
    <form className={props.classes.form} noValidate>
      <TextField
        inputRef={emailInputRef}
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="email"
        name="email"
        label="Email"
        type="email"
        autoFocus
      />
      {notification && <Alert severity={notification.variant}>{notification.message}</Alert>}
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        onClick={sendResetLinkButtonHandler}
        className={props.classes.submit}
      >
        Reset
      </Button>
    </form>
  );
};

export default SendResetLinkForm;
